import { render, staticRenderFns } from "./ScentDetectionShowResultsEntry.vue?vue&type=template&id=28e16a94"
import script from "./ScentDetectionShowResultsEntry.vue?vue&type=script&lang=ts"
export * from "./ScentDetectionShowResultsEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports